import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScrollHelper } from '@app/@shared/utils/scroll-helper';
import { HTMLReport, Image } from '@app/@shared/services/hygraph/hygraph.models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ImageModalComponent} from '@shared/components/hygraph/image-modal/image-modal.component';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-hygraph',
  templateUrl: './hygraph.component.html',
  styleUrls: ['./hygraph.component.scss'],
})
export class HygraphComponent {
  @Input() reportTitle: string;
  @Input() htmlReport: HTMLReport;
  @Input() lockedMessage: string;

  private anchorId: string; // section anchor needed so we can scroll to specfic section of a page

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit(): void {
    // Retrive an array of section anchors so we could modify each one to our needs
    const sectionAnchor = Array.from(document.getElementsByClassName(ScrollHelper.SECTION_ANCHOR));
    sectionAnchor.forEach((anchor) => this.mapAnchors(anchor as HTMLAnchorElement))

    /**
     * Listening to url query changes and scrolling to anchor section when applicable
     * A delay of 500ms has been added in order to allow images to fully load before calculating
     * element postion of anchor, this is done because the value is different before and after delay
     * causing incorrect behavior, WARNING on slow network this will still be an issue the following
     * TECHDEBT https://techinsights.atlassian.net/browse/SWDEV-15684
     */
    this.route.queryParamMap.pipe(
      delay(500)
    ).subscribe((queryParams) => {
      if (queryParams.has('anchor')){
        ScrollHelper.scrollToSection(queryParams.get('anchor'));
      }
    });
  }

  openImageModal(image: Image) {
    if(window.innerWidth >= 600) {
      const modalRef = this.modalService.open(ImageModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.image = image;
    } else if(image.sourceUrl) {
      window.open(image.sourceUrl, "_blank");
    }
  }

  /**
   * Creating correct url for section anchors for href
   * @param elementId
   * @returns url tree for anchor href
   */
  createURLTreeHref(elementId: string){
    return this.router.serializeUrl(
      this.router.createUrlTree(
        [],{
          queryParams: {anchor: elementId},
          preserveFragment: true
        }
    ));
  }

  /**
   * Provide an anchor element we add a click event listener which retireves
   * the anchor id and scroll to that section, also we are modifiying the href to
   * the correct url needed
   * @param anchor
   */
  private mapAnchors(anchor: HTMLAnchorElement){
    const elementId = anchor.title
    anchor.href= this.createURLTreeHref(elementId);
    anchor.addEventListener('click', (event: any)=>{
      event.stopPropagation()
      event.preventDefault()
      if(this.anchorId === elementId){
        ScrollHelper.scrollToSection(elementId)
      } else {
        this.anchorId = elementId;
        this.router.navigate([],{
          queryParams: {anchor: elementId},
          preserveFragment: true
        })
      }
    })
  }

}
